import React, { useState, useEffect, useContext } from "react";
import { Box } from "@mui/material";

import TableStyle from "components/Content/Table/TableStyle.module.css";
import TableAllData from "components/Content/CustomTable/TableAllData";

import LoaderAnimation from "pages/LoaderAnimation";

import { apiGet } from "app/Services/ApiService";
import { apiUrls } from "common/ApiUrls";
import { PrivateRoutesContext } from "app/PrivateRoutesContext";
import { Utils } from "common/Utils";

export default function TimeSheetsTable({ payDate, isLoading, canDownload }) {
    const { companyId } = useContext(PrivateRoutesContext);

    const [columnsArray, setColumnsArray] = useState([]);
    const [timeSheets, setTimeSheets] = useState([]);
    const [isLoadingTimeSheets, setIsLoadingTimeSheets] = useState(false);

    useEffect(() => {
        setIsLoadingTimeSheets(true);
        apiGet(apiUrls.getTimeSheets(companyId, payDate))
            .then((response) => {
                getDynamicColumns(response.data);
                setColumnsArray(columns);
                setTimeSheets(response.data.employeeHours);
            })
            .catch((error) => { 
                setColumnsArray([]);
                setTimeSheets([]);
            })
            .finally(() => {
                setIsLoadingTimeSheets(false);
            });
    },[companyId, payDate])

    let columns = [
        {
          Header: "Name",
          accessor: "name",
        },
        {
          Header: "SSN",
          accessor: "ssn",
        },
        {
          Header: "Pay Period",
          accessor: (cell) => Utils.formatDate(cell.payPeriodDate),
          Cell: ({row}) => (
            <Box>
              {Utils.formatDate(row.original.payPeriodDate)}
            </Box>
          ),
          sortType: "dateSort",
        },
        {
          Header: "Start Date",
          accessor: (cell) => Utils.formatDate(cell.startDate),
          Cell: ({row}) => (
            <Box>
              {Utils.formatDate(row.original.startDate)}
            </Box>
          ),
          sortType: "dateSort",
        },
        {
          Header: "End Date",
          accessor: (cell) => Utils.formatDate(cell.endDate),
          Cell: ({row}) => (
            <Box>
              {Utils.formatDate(row.original.endDate)}
            </Box>
          ),
          sortType: "dateSort",
        },
        {
          Header: "Total Hours",
          accessor: "totalHours",
        },
      ];
    
    function getColmunValue (item) {
        if (item) {
            return item.replace("Header", "");
        }
    }
    
    function getDynamicColumns (data) {
        Object.keys(data).map((item, index) => {
            if (data[item] !== null
                && item !== "employeeHours"
                && item !== "currentPayDate"
            ) {
                columns.push({ Header: data[item], accessor: getColmunValue(item) });
            }
        });
    }

  const initialTableState={
    pageIndex: 0, 
    pageSize: 10,
    sortBy: [
        {
            id: 'name',
            desc: false
        }
    ]
  }

    return (
        <Box>
            {isLoading || isLoadingTimeSheets ? <LoaderAnimation centerAtPage={true}/>
            : timeSheets.length === 0 ?
                <span>No Records Found, please select a different pay date.</span>
            :
                <TableAllData
                    className={TableStyle.TimeSheetsWrapper}
                    columns={columnsArray}
                    data={timeSheets}
                    initialState={initialTableState}
                    download={canDownload ? { prefix: "TimeSheets", table: "TimeSheets" } : null}
                />
            }
        </Box>
    )
}